import { rdRequests } from "../httpRequest";

const googleApiRequest = {
  getGoogleTagManagerId: () => rdRequests.get('google/TagManagerId')
}

export default googleApiRequest;